"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _clsx = _interopRequireDefault(require("clsx"));

var _styles = require("@material-ui/core/styles");

var _GridAreaContainer = _interopRequireDefault(require("@sprinx/react-mui-components/GridAreaContainer"));

var _AvailabilityFieldPreview = _interopRequireDefault(require("../../../components/AvailabilityFieldPreview"));

var _useProductDetailShippingDateComponent = _interopRequireDefault(require("../../../hooks/useProductDetailShippingDateComponent"));

var useStyles = (0, _styles.makeStyles)(function (theme) {
  return {
    root: (0, _extends2.default)({}, theme.typography.body1),
    container: {
      display: 'flex',
      alignItems: 'center',
      paddingBottom: theme.spacing(1),
      justifyContent: 'center',
      flexDirection: 'row'
    },
    mobShippingDertail: {
      color: theme.palette.secondary.main,
      fontSize: 14,
      fontWeight: 300,
      lineHeight: 1.5,
      justifyContent: 'center',
      paddingLeft: theme.spacing(1),
      flexGrow: 1,
      maxWidth: '50%',
      textAlign: 'center'
    },
    shippingQuantity: {
      fontSize: 14,
      fontWeight: 'bold',
      lineHeight: 1.5
    },
    availabilityText: {
      fontSize: 14,
      fontWeight: 300,
      lineHeight: 1.5,
      minHeight: 50,
      display: 'flex',
      alignItems: 'center',
      paddingRight: theme.spacing(1),
      marginLeft: 'auto',
      justifyContent: 'center'
    },
    productDetailMobWrapper: {
      width: '50%',
      display: 'flex',
      justifyContent: 'center',
      borderRight: '1px solid',
      borderRightColor: theme.palette.another.grey
    }
  };
}, {
  name: 'ProductDetailStockInfoMobile'
});

function ProductDetailStockInfoMobile(_ref) {
  var available = _ref.available,
      pClasses = _ref.classes,
      className = _ref.className,
      delInfo = _ref.delInfo,
      product = _ref.product,
      renderToGridArea = _ref.renderToGridArea,
      shipping = _ref.shipping,
      rest = (0, _objectWithoutProperties2.default)(_ref, ["available", "classes", "className", "delInfo", "product", "renderToGridArea", "shipping"]);
  var classes = useStyles({
    classes: pClasses
  });
  var ProductDetailShippingDate = (0, _useProductDetailShippingDateComponent.default)();
  return /*#__PURE__*/_react.default.createElement(_GridAreaContainer.default, (0, _extends2.default)({}, rest, {
    renderToGridArea: renderToGridArea,
    className: (0, _clsx.default)(classes.root, className)
  }), /*#__PURE__*/_react.default.createElement("div", {
    className: classes.container
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: classes.productDetailMobWrapper
  }, /*#__PURE__*/_react.default.createElement(_AvailabilityFieldPreview.default, {
    product: product,
    delInfo: delInfo,
    classes: {
      inStore: classes.availabilityText,
      soldout: classes.availabilityText
    }
  })), shipping && shipping.warehouse && /*#__PURE__*/_react.default.createElement("div", {
    className: classes.mobShippingDertail
  }, /*#__PURE__*/_react.default.createElement(ProductDetailShippingDate, {
    shipping: shipping,
    classes: {
      quantity: classes.shippingQuantity
    }
  }))));
}

process.env.NODE_ENV !== "production" ? ProductDetailStockInfoMobile.propTypes = {
  available: _propTypes.default.bool,
  classes: _propTypes.default.shape({
    availabilityText: _propTypes.default.string,
    container: _propTypes.default.string,
    free: _propTypes.default.string,
    labelsContainer: _propTypes.default.string,
    mobShippingDertail: _propTypes.default.string,
    notAvailable: _propTypes.default.string,
    productDetailMobWrapper: _propTypes.default.string,
    root: _propTypes.default.string,
    separator: _propTypes.default.string,
    shippingQuantity: _propTypes.default.string,
    showroom: _propTypes.default.string,
    text: _propTypes.default.string
  }),
  className: _propTypes.default.string,
  delInfo: _propTypes.default.shape({
    deliveryDates: _propTypes.default.arrayOf(_propTypes.default.shape({})),
    warehouse: _propTypes.default.string
  }),
  product: _propTypes.default.shape({
    adornments: _propTypes.default.arrayOf(_propTypes.default.shape({})),
    id: _propTypes.default.string.isRequired,
    stockQuantity: _propTypes.default.shape({
      available: _propTypes.default.bool,
      detail: _propTypes.default.arrayOf(_propTypes.default.shape({
        date: _propTypes.default.string,
        icon: _propTypes.default.node,
        location: _propTypes.default.string
      }))
    })
  }),
  renderToGridArea: _propTypes.default.string,
  shipping: _propTypes.default.shape({
    latestOrderTime: _propTypes.default.shape({}),
    shippingDate: _propTypes.default.shape({}),
    warehouse: _propTypes.default.string
  })
} : void 0;
ProductDetailStockInfoMobile.defaultProps = {
  available: false,
  classes: undefined,
  className: undefined,
  delInfo: undefined,
  product: undefined,
  renderToGridArea: 'stockInfo',
  shipping: undefined
};
var _default = ProductDetailStockInfoMobile;
exports.default = _default;